import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  /*
  {
    name: 'id',
    label: i18n('entities.position.fields.id'),
  },
  */
  {
    name: 'name',
    label: i18n('entities.position.fields.name'),
  },
  {
    name: 'displayOrder',
    label: i18n('entities.position.fields.displayOrder'),
  },
  /*
  {
    name: 'createdAt',
    label: i18n('entities.position.fields.createdAt'),
    render: exporterRenders.datetime(),
  },  
  {
    name: 'updatedAt',
    label: i18n('entities.position.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
  */
];
